module.exports = __webpack_public_path__ + "static/media/team-bg.efdc4e1a.jpg";